import styled from 'styled-components';
import { Card } from 'ui-toolkit';

export const ValidationSummaryStyled = styled(Card)<{}>`
  border: solid 1px ${(props) => props.theme.colors.error};
  border-radius: ${(props) => props.theme.spacing.spacing2};
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
`;

export const ValidationSummaryContentStyled = styled.h2<{}>`
  ${(props) => props.theme.fonts.mixins.boldHeader2};
`;

export const ValidationListStyled = styled.div<{ level: number }>`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing2};
  padding-left: ${(props) => 4 * props.level * props.theme.spacing.baseValue + props.theme.spacing.baseUnit};
`;

export const ValidationMessageStyled = styled.div<{}>`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing2};
  grid-template-columns: min-content 1fr;
`;

export const ValidationMessageTagStyled = styled.div<{ isValid: boolean }>`
  border: solid 1px ${(props) => (props.isValid ? props.theme.colors.primary : props.theme.colors.error)};
  border-radius: ${(props) => props.theme.spacing.spacing2};
  color: ${(props) => (props.isValid ? props.theme.colors.primary : props.theme.colors.error)};
  padding: 0 ${(props) => props.theme.spacing.spacing2};
`;
